import IrosIndicators from "./IrosIndicators";

export default IrosIndicators